import React, { useEffect, useState } from 'react';
import './Footer.css';
import { useLanguage } from '../context/LanguageContext';
import Logo from './Logo';
import Icon from './Icon';

const Footer = ({ setCurrentPage }) => {
  const { t, language } = useLanguage();
  const [visitCount, setVisitCount] = useState(0);

  useEffect(() => {
    const totalVisitsKey = 'websiteVisitCount';
    const sessionVisitKey = 'websiteVisitTracked';
    const hasTrackedThisSession = sessionStorage.getItem(sessionVisitKey);
    const savedCount = Number(localStorage.getItem(totalVisitsKey) || '0');

    if (!hasTrackedThisSession) {
      const nextCount = savedCount + 1;
      localStorage.setItem(totalVisitsKey, String(nextCount));
      sessionStorage.setItem(sessionVisitKey, 'true');
      setVisitCount(nextCount);
      return;
    }

    setVisitCount(savedCount);
  }, []);

  const handleNavClick = (pageId) => {
    setCurrentPage(pageId);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <div className="footer-logo-container" style={{ marginBottom: '20px' }}>
            <Logo variant="white" />
          </div>
          <p className="footer-description">
            {t('footer.description1')}
          </p>
          <p className="footer-description">
            {t('footer.description2')}
          </p>
        </div>

        <div className="footer-section">
          <h4>{t('footer.quickLinks')}</h4>
          <ul className="footer-links">
            <li><button onClick={() => handleNavClick('home')}>{t('nav.home')}</button></li>
            <li><button onClick={() => handleNavClick('about')}>{t('nav.about')}</button></li>
            <li><button onClick={() => handleNavClick('gallery')}>{t('nav.gallery')}</button></li>
            <li><button onClick={() => handleNavClick('events')}>{t('nav.events')}</button></li>
            <li><button onClick={() => handleNavClick('donation')}>{t('nav.donation')}</button></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.importantLinks')}</h4>
          <ul className="footer-links">
            <li><button onClick={() => handleNavClick('tenders')}>{t('nav.tenders')}</button></li>
            <li><button onClick={() => handleNavClick('committee')}>{t('nav.committee')}</button></li>
            <li><button onClick={() => handleNavClick('location')}>{t('nav.location')}</button></li>
            <li><button onClick={() => handleNavClick('aaras-download')}>{t('nav.download')}</button></li>
            <li><button onClick={() => handleNavClick('contact')}>{t('nav.contact')}</button></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>{t('footer.contact')}</h4>
          <div className="footer-contact">
            <p>
              <Icon name="location" />
              <span className="contact-text">{t('footer.addressText')}</span>
            </p>
            <p>
              <Icon name="phone" />
              <span className="contact-text">
                <a href="tel:+918275100238" className="footer-contact-link">+91 8275100238</a>
                <span className="phone-separator"> / </span>
                <a href="tel:+918275100273" className="footer-contact-link">+91 8275100273</a>
              </span>
            </p>
            <p>
              <Icon name="mail" />
              <span className="contact-text">
                <a href="mailto:koditnathmhaskoba63@gmail.com" className="footer-contact-link">koditnathmhaskoba63@gmail.com</a>
              </span>
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/shrinath.mhaskoba.kodit/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"></path>
                </svg>
              </a>
              <a href="https://www.instagram.com/shrinath_mhaskoba_mandir_kodit?utm_medium=copy_link" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                  <path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"></path>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                </svg>
              </a>
              <a href="https://www.youtube.com/@kodit_devasthan" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                  <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"></path>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <p>{t('footer.copyright')}</p>
        </div>
        <div className="footer-visit-counter">
          <span className="footer-visit-label">{t('footer.visitCountLabel')}</span>
          <strong className="footer-visit-value">{visitCount.toLocaleString(language === 'mr' ? 'mr-IN' : 'en-IN')}</strong>
        </div>
        <div className="footer-bottom-right">
          <p>{t('footer.developedBy')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;


